import { FieldType } from "./types";
import type { FieldConfig, ToolDependency, ToolDependencyFormRow } from "./types";

const createToolDependencyId = (): string => {
  if (typeof globalThis.crypto !== "undefined" && "randomUUID" in globalThis.crypto) {
    return globalThis.crypto.randomUUID();
  }

  return `tool-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
};

export const FIELD_CONFIG: FieldConfig[] = [
  {
    yamlKey: "interface.display_name",
    section: "interface",
    label: "Display Name",
    type: FieldType.Text,
    placeholder: "My Skill",
    description: "User-facing name shown in the Codex app",
  },
  {
    yamlKey: "interface.short_description",
    section: "interface",
    label: "Short Description",
    type: FieldType.Textarea,
    placeholder: "A brief description of what this skill does",
    description: "User-facing description (25-64 characters recommended)",
  },
  {
    yamlKey: "interface.brand_color",
    section: "interface",
    label: "Brand Color",
    type: FieldType.Color,
    placeholder: "#3B82F6",
    description: "Hex color code for UI branding",
  },
  {
    yamlKey: "interface.default_prompt",
    section: "interface",
    label: "Default Prompt",
    type: FieldType.Textarea,
    placeholder: "Optional surrounding prompt context",
    description: "Optional surrounding prompt for skill usage",
  },
  {
    yamlKey: "policy.allow_implicit_invocation",
    section: "policy",
    label: "Allow implicit invocation",
    type: FieldType.Boolean,
    defaultValue: true,
    description: "When enabled, Codex can auto-trigger the skill based on context",
  },
];

export const SECTION_LABELS: Record<string, string> = {
  interface: "Interface",
  policy: "Policy",
  dependencies: "Dependencies",
};

export const createEmptyTool = (): ToolDependency => ({
  _id: createToolDependencyId(),
  type: "mcp",
  value: "",
  description: "",
  transport: "streamable_http",
  url: "",
});

export const TOOL_DEPENDENCY_FORM_ROWS: ToolDependencyFormRow[] = [
  {
    columns: 2,
    fields: [
      {
        key: "type",
        label: "Type",
        placeholder: "mcp",
        disabled: true,
        tooltip: "This can only be set to MCP",
      },
      { key: "value", label: "Value", placeholder: "toolName" },
    ],
  },
  {
    columns: 1,
    fields: [{ key: "description", label: "Description", placeholder: "What this tool does" }],
  },
  {
    columns: 2,
    fields: [
      {
        key: "transport",
        label: "Transport",
        placeholder: "streamable_http",
        inputType: "select",
        options: [
          { label: "Streamable HTTP", value: "streamable_http" },
          { label: "stdio", value: "stdio" },
        ],
      },
      {
        key: "url",
        label: "URL",
        placeholder: "example.com/mcp",
        inputType: "url",
      },
    ],
  },
];
